var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5273 4.61737L3.08065 4.61737L6.33399 1.36404C6.59399 1.10404 6.59399 0.677369 6.33399 0.41737C6.07399 0.157369 5.65399 0.157369 5.39399 0.41737L1.00065 4.8107C0.875819 4.93526 0.805664 5.10436 0.805664 5.2807C0.805664 5.45705 0.875819 5.62615 1.00065 5.7507L5.38732 10.1507C5.64732 10.4107 6.06732 10.4107 6.32732 10.1507C6.58732 9.8907 6.58732 9.4707 6.32732 9.2107L3.08065 5.9507L10.5273 5.9507C10.894 5.9507 11.194 5.6507 11.194 5.28404C11.194 4.91737 10.894 4.61737 10.5273 4.61737Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevIcon);
export default __webpack_public_path__ + "static/media/prev-icon.7e93f47f.svg";
export { ForwardRef as ReactComponent };